import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button } from "antd";
import Component from "../../../components";
import Validation from "../../../utils/Validation";
import Constants from "../../../utils/Constants";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import MaintenanceAction from "../../../redux/actions/AuthAction/MaintenanceAction";
import Spinner from "../../../components/Spinner/Spiner";
import { getStates, getCities, getCommunities } from "../../../services/LocationService";
const getUniqueRecords = (data, keys) => {
  data.sort((a, b) => a.name.localeCompare(b.name))
  const seen = new Set();
  return data.filter((item) => {
    const keyss = keys.map((k) => item[k]?.trim()).join('|')
    const key = keys.map((k) => item[k]?.trim()).join('|');
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
};
const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
const Maintenance = () => {
  const dispatch = useDispatch();
  const { TextInput, SelectBox, UploadButton, TextArea } = Component;
  const [form] = Form.useForm();
  const [maintenance, setMaintenance] = useState({});
  const [newStates, setNewStates] = useState([]);
  const [city, setCity] = useState([]);
  const [cityNames, setCityNames] = useState([]);
  const [communities, setCommunities] = useState([]);
  const [loadingLocations, setLoadingLocations] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);

  const maintenanceRes = useSelector((state) => state?.CreateMaintenance);
  
  const getUniqueRecords = (data, keys) => {
  data.sort((a, b) => a.name.localeCompare(b.name));
  const seen = new Set();
  return data.filter((item) => {
    const key = keys.map((k) => item[k]?.trim()).join('|');
    if (seen.has(key)) {
      return false;
    }
    if (key?.trim() !== '|') {
      seen.add(key);
      return true;
    }
    return false;
  });
  };
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleChange = ({ fileList: newFileList }) => {
    let fileNames = [];
    let i = 0;
    newFileList.forEach((file) => {
      if (i == 0) {
        fileNames = [...fileNames, file.name];
        i = i + 1;
      } else {
        if (fileNames.includes(file.name)) {
          Swal.fire({
            title: "Warning",
            text: "File name already exists.(" + file.name + ")",
            icon: "warning",
            confirmButtonColor: "#44637e",
          });
          newFileList.splice(newFileList.indexOf(file), 1);
        } else {
          fileNames = [...fileNames, file.name];
        }
      }
      setFileList(fileNames);
    });
    const maxSize = 5 * 1024 * 1024 * 1024;
    let totalSize = 0;
    let filesChecked = [];
    newFileList.forEach((file) => {
      totalSize = totalSize + file?.originFileObj?.size;
      if (totalSize > maxSize) {
        Swal.fire({
          title: "Warning",
          text: "Cannot upload files larger than 5 GB.",
          icon: "warning",
          confirmButtonColor: "#44637e",
        });
      } else {
        filesChecked.push(file);
      }
    });
    setFileList(filesChecked);
  };
  const onFinish = async (values) => {
    try {
      const formData = new FormData();
      formData.append("state", values.state);
      formData.append("City", values.city);
      formData.append("CommunityId", values.communities);
      formData.append("userFirstName", values.firstName);
      formData.append("userLastName", values.lastName);
      formData.append("userAddress", values.address);
      formData.append("userCity", values.cityName);
      formData.append("userState", values.stateName);
      formData.append("userZip", values.zip);
      formData.append("userDayTimePhone", values.phone);
      formData.append("userEmail", values.email);
      formData.append("userResidentKey", values.residentKey ?? 0);
      formData.append("maintenanceLocation", values.maintenanceLocation);
      formData.append("maintenanceConcern", values.maintenanceConcern);

      fileList.forEach((file, index) => {
        formData.append(`attachments`, file.originFileObj, file.name);
      });
      let req = {
        request: formData,
        handle: HandleRes,
      };

      if (formData) {
        dispatch(MaintenanceAction.CreateMaintennceRequest(req));
      }
    } catch (error) {
      Swal.fire({
        text: "Submission unsuccessful. Please try again or contact us.",
        icon: "error",
        confirmButtonColor: "#5A7890",
        customClass: {
          title: "text-danger",
          content: "text-danger",
        },
      });
    }
  };
  const HandleRes = () => {
    handleClearButton();
  };
  const onFinishFailed = (errorInfo) => {

  };
  const HandleOnChange = async (e) => {
  const { id, value } = e?.target;
  const updatedMaintenance = { ...maintenance, [id]: value };
  setMaintenance(updatedMaintenance);
  form.setFieldsValue(updatedMaintenance);

  // Community selector: state -> cities
  if (id === "state") {
    const a = { stateName: value };
    form.setFieldsValue(a);
    form.resetFields(["city", "communities"]);
    setLoadingLocations(true);
    try {
      const res = await getCities(value);
      const newCities = (res?.data || []).map((c) => ({ name: c.cityName, value: c.cityId }));
      const uniqueCities = getUniqueRecords(newCities, ["name", "value"]);
      const selectorCities = uniqueCities.filter(
        (c) => !Constants.EXCLUDED_CITIES.includes(c.name?.trim().toLowerCase())
      );
      setCity(selectorCities);
      setCityNames(uniqueCities);
    } catch (error) {
      Swal.fire({ text: "Unable to load cities. Please try again or contact us.", icon: "error", confirmButtonColor: "#5A7890" });
    } finally {
      setLoadingLocations(false);
    }
  }

  if (id === "stateName") {
    form.resetFields(["cityName"]);
    setLoadingLocations(true);
    try {
      const res = await getCities(value);
      const newCities = (res?.data || []).map((c) => ({ name: c.cityName, value: c.cityId }));
      setCityNames(getUniqueRecords(newCities, ["name", "value"]));
    } catch (error) {
      Swal.fire({ text: "Unable to load cities. Please try again or contact us.", icon: "error", confirmButtonColor: "#5A7890" });
    } finally {
      setLoadingLocations(false);
    }
  }

  // city -> communities
  if (id === "city") {
    const a = { cityName: value };
    form.setFieldsValue(a);
    form.resetFields(["communities"]);
    const selectedState = form.getFieldValue("state");
    setLoadingLocations(true);
    try {
      const res = await getCommunities(selectedState, value);
      const newCommunities = (res?.data || [])
        .map((c) => ({ name: c.communityName, value: c.communityId }));
      setCommunities(getUniqueRecords(newCommunities, ["name", "value"]));
    } catch (error) {
      Swal.fire({ text: "Unable to load communities. Please try again or contact us.", icon: "error", confirmButtonColor: "#5A7890" });
    } finally {
      setLoadingLocations(false);
    }
  }
  };

  const validationRules = Validation.getValidation([
    "state",
    "city",
    "communities",
    "firstName",
    "lastName",
    "address",
    "cityName",
    "stateName",
    "zip",
    "phone",
    "email",
    "residentKey",
    "maintenanceLocation",
    "maintenanceConcern",
    "files",
  ]);

  function handleClearButton() {
    form.resetFields(); 
    setFileList([]); 
    setPreviewImage(""); 
    setPreviewOpen(false); 
    setMaintenance({}); 
    setCity([]); 
    setCommunities([]); 
  }

  useEffect(() => {
    (async () => {
    setLoadingLocations(true);
    try {
      const res = await getStates();
      const list = (res?.data || []).map((s) => ({ name: s.stateName, value: s.stateId }));
      setNewStates(list);
    } catch (error) {
      Swal.fire({
        text: "Unable to load states. Please try again or contact us.",
        icon: "error",
        confirmButtonColor: "#5A7890",
      });
    } finally {
      setLoadingLocations(false);
    }
  })();
  }, []);
  const onSearch = (value) => {
    console.log(value)
   };
  
   const filterOption = (input, option) =>
     (option?.children ?? "").toLowerCase().includes(input.toLowerCase());
   
  return (
    <>
      {(loadingLocations || maintenanceRes?.loading) && <Spinner />}
      <Row justify={"center"}>
        {/* <Col sm={20} className="text-center">
          <div className="text-center mt-5">
            <h1 className="heading-maintenance" style={{ color: "#5A7890" }}>
              Maintenance Request
            </h1>
          </div>
        </Col> */}
        <Col sm={20} className="a">
          <div className="mt-5">
            <p
              className="description-maintenance"
              style={{ fontSize: "20px", marginBottom: "4rem" }}
            >
              Please complete this form to request maintenance on any common
              areas in your community. Please note - AAM Maintenance Requests do
              not cover areas owned by municipalities or individual owners. If
              you have any questions, please contact your Community Manager.
            </p>
          </div>
        </Col>
        <Col sm={20}>
          <Form
            style={{ marginBottom: "12rem" }}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            initialValues={{}}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            form={form}
          >
            <SelectBox
              label="State"
              name="state"
              options={getUniqueRecords(newStates, ['name', 'value'])}
              className="custom-scrollbar"
              placeholder="State"
              onChange={(e) => HandleOnChange(e)}
              size="large"
              rules={validationRules.state}
              showSearch={true}
              onSearch={onSearch}
              filterOption={filterOption} 
            />

            {form.getFieldValue("state") && (
              <SelectBox
                label="City"
                name="city"
                options={getUniqueRecords(city, ['name', 'value'])}
                className="custom-scrollbar"
                placeholder="City"
                onChange={(e) => HandleOnChange(e)}
                size="large"
                rules={validationRules.city}
                showSearch={true}
                onSearch={onSearch}
                filterOption={filterOption} 
              />
            )}

            {form.getFieldValue("city") && (
              <SelectBox
                label="Communities"
                name="communities"
                options={getUniqueRecords(communities, ['name', 'value'])}
                className="custom-scrollbar"
                placeholder="Communities"
                onChange={(e) => HandleOnChange(e)}
                size="large"
                rules={validationRules.communities}
                showSearch={true}
                onSearch={onSearch}
                filterOption={filterOption} 
              />
            )}
            {form.getFieldValue("communities") && (
              <>
                <TextInput
                  rules={validationRules.firstName}
                  name="firstName"
                  size="large"
                  label="First Name"
                  placeholder="Enter First Name"
                  onChange={(e) => HandleOnChange(e)}
                />
                <TextInput
                  rules={validationRules.lastName}
                  name="lastName"
                  size="large"
                  label="Last Name"
                  placeholder="Enter Last Name"
                  onChange={(e) => HandleOnChange(e)}
                />
                <TextInput
                  rules={validationRules.address}
                  name="address"
                  size="large"
                  label="Your Address"
                  placeholder="Enter Your Address"
                  onChange={(e) => HandleOnChange(e)}
                />
                <SelectBox
                  label="Your State"
                  name="stateName"
                  options={getUniqueRecords(newStates, ['name', 'value'])}
                  className="custom-scrollbar"
                  placeholder="Choose State"
                  onChange={(e) => HandleOnChange(e)}
                  size="large"
                  rules={validationRules.state}
                  showSearch={true}
                  onSearch={onSearch}
                  filterOption={filterOption} 
                />

                <SelectBox
                  label="Your City"
                  name="cityName"
                  options={getUniqueRecords(cityNames, ['name', 'value'])}
                  className="custom-scrollbar"
                  placeholder="Choose City"
                  onChange={(e) => HandleOnChange(e)}
                  size="large"
                  rules={validationRules.city}
                  showSearch={true}
                  onSearch={onSearch}
                  filterOption={filterOption} 
                />

                <TextInput
                  rules={validationRules.zip}
                  name="zip"
                  size="large"
                  label="Your Zip"
                  placeholder="Enter Your Zip"
                  onChange={(e) => HandleOnChange(e)}
                />
                <TextInput
                  rules={validationRules.phone}
                  name="phone"
                  size="large"
                  label="Daytime Phone"
                  placeholder="Enter Daytime Phone"
                  onChange={(e) => HandleOnChange(e)}
                />
                <TextInput
                  rules={validationRules.email}
                  name="email"
                  size="large"
                  label="Email Address"
                  placeholder="Enter Email Address"
                  onChange={(e) => HandleOnChange(e)}
                />
                <TextInput
                  name="residentKey"
                  size="large"
                  label="Account Number"
                  placeholder="Enter Account Number"
                  onChange={(e) => HandleOnChange(e)}
                />
                <TextArea
                  rows={6}
                  rules={validationRules.maintenanceLocation}
                  name="maintenanceLocation"
                  size="large"
                  label="Maintenance Location"
                  placeholder="Enter Maintenance Location"
                  onChange={(e) => HandleOnChange(e)}
                />
                <TextArea
                  rows={6}
                  rules={validationRules.maintenanceConcern}
                  name="maintenanceConcern"
                  size="large"
                  label="Maintenance Concern"
                  placeholder="Enter Maintenance Concern"
                  onChange={(e) => HandleOnChange(e)}
                />
                <UploadButton
                  handlePreview={handlePreview}
                  fileList={fileList}
                  setFileList={setFileList}
                  setPreviewImage={setPreviewImage}
                  previewImages={previewImage}
                  setPreviewOpen={setPreviewOpen}
                  previewOpen={previewOpen}
                  name="files"
                  handleChange={handleChange}
                  number={10}
                />
              </>
            )}
            <Button
              onClick={handleClearButton}
              style={{
                marginLeft: 8,
                borderRadius: 19,
                border: "1px solid #5A7890",
                color: "#5A7890",
                backgroundColor: "#fff",
                height: "2.5rem",
                width: "8rem",
              }}
            >
              Clear
            </Button>
            <Button
              htmlType="submit"
              class="submit-button"
              style={{
                marginLeft: 8,
                borderRadius: 19,
                color: "white",
                backgroundColor: "#5A7890",
                height: "2.5rem",
                width: "8rem",
              }}
            >
              Submit
            </Button>
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default Maintenance;
